import Grid from '@mui/material/Grid';
import { ReactElement } from 'react';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

import { IBloodDrawn, IToxicology } from '../AddVisit/types';
import BloodDrawn from './BloodDrawn';
import Toxicology from './Toxicology';

interface ITestingProps<TFieldValues extends FieldValues = FieldValues> {
  toxicology: IToxicology | null;
  bloodDrawn: IBloodDrawn | null;
  control: Control<TFieldValues>;
  errors: FieldErrors;
}

const Testing = <TFieldValues extends FieldValues = FieldValues>({
  toxicology,
  bloodDrawn,
  control,
  errors,
}: ITestingProps<TFieldValues>): ReactElement => (
  <Grid
    container
    size={{
      sm: 12,
    }}
  >
    <Grid
      size={{
        sm: 12,
      }}
    >
      <Toxicology toxicology={toxicology} control={control} errors={errors} />
    </Grid>
    <Grid
      size={{
        sm: 12,
      }}
    >
      <BloodDrawn bloodDrawn={bloodDrawn} control={control} errors={errors} />
    </Grid>
  </Grid>
);

export default Testing;
